// extracted by mini-css-extract-plugin
module.exports = {"homeBanner":"index_homeBanner__ihf3p","btn":"index_btn__DNhRt"};